module Meevo.Components.Controls {
  class PostalCodeResultsController {

    static $inject = ["$mdDialog", "choices"];

    constructor(private $mdDialog: angular.material.IDialogService, private choices: any) {
    }

    selectResult = (selection: any): void => {
      this.$mdDialog.hide(selection);
    }

    close = (): void => {
      this.$mdDialog.hide();
    }
  }

  angular.module("meevo.components.controls")
    .controller("meevo.components.controls.PostalCodeResultsController", PostalCodeResultsController);
}